import { ArrowRight, Calendar } from 'lucide-react';

const blogPosts = [
  {
    id: 1,
    title: 'El futuro de la agricultura de precisión en Argentina',
    excerpt: 'Descubre cómo la tecnología satelital y los drones están revolucionando la forma de trabajar el campo.',
    image: 'https://images.unsplash.com/photo-1721594489297-963f5e24abe1?w=800&q=80',
    date: '15 Dic 2024',
    category: 'Tecnología',
    readTime: '5 min lectura'
  },
  {
    id: 2,
    title: 'Consejos para maximizar tu cosecha esta temporada',
    excerpt: 'Tips prácticos de expertos para optimizar el rendimiento de tus cultivos y reducir pérdidas.',
    image: 'https://images.unsplash.com/photo-1708975477074-71e2907b699f?w=800&q=80',
    date: '10 Dic 2024',
    category: 'Consejos',
    readTime: '4 min lectura'
  },
  {
    id: 3,
    title: 'Financiamiento agropecuario: opciones y beneficios',
    excerpt: 'Conoce las alternativas de crédito disponibles para productores y cómo acceder a ellas.',
    image: 'https://images.unsplash.com/photo-1708794666324-85ad91989d20?w=800&q=80',
    date: '5 Dic 2024',
    category: 'Finanzas',
    readTime: '6 min lectura'
  }
];

export const BlogSection = () => {
  return (
    <section
      id="blog"
      className="py-16 md:py-24 bg-[#EBE9BD]"
      data-testid="blog-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <span className="inline-block text-sm font-bold uppercase tracking-[0.2em] text-[#AB6D4C] mb-4">
              Blog & Noticias
            </span>
            <h2 className="text-4xl md:text-5xl font-medium tracking-tight text-[#051914]">
              Últimas novedades
            </h2>
          </div>
          <a 
            href="#blog" 
            className="inline-flex items-center gap-2 text-[#051914] font-medium hover:text-[#A9CB68] transition-colors"
            data-testid="blog-view-all"
          >
            Ver todos los artículos
            <ArrowRight size={18} />
          </a>
        </div>

        {/* Blog Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {blogPosts.map((post) => (
            <article
              key={post.id}
              className="group bg-[#FBF5EA] rounded-3xl overflow-hidden hover:shadow-xl transition-all hover:-translate-y-2"
              data-testid={`blog-post-${post.id}`}
            >
              {/* Image */}
              <div className="relative h-56 overflow-hidden bg-[#EBE9BD]">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 bg-[#AB6D4C] text-[#FBF5EA] rounded-full text-xs font-medium">
                    {post.category}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="flex items-center gap-4 text-xs text-[#051914]/50 mb-3">
                  <span className="flex items-center gap-1">
                    <Calendar size={14} />
                    {post.date}
                  </span>
                  <span>{post.readTime}</span>
                </div>

                <h3 className="text-lg font-medium text-[#051914] mb-2 line-clamp-2 group-hover:text-[#A9CB68] transition-colors">
                  {post.title}
                </h3>

                <p className="text-sm text-[#051914]/60 line-clamp-2 mb-4">
                  {post.excerpt}
                </p>

                <a 
                  href="#blog" 
                  className="inline-flex items-center gap-2 text-sm font-medium text-[#051914] hover:text-[#A9CB68] transition-colors"
                >
                  Leer más
                  <ArrowRight size={16} />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
